<template>
    <console-content max-width="1280px">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">캐시 내역</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.createdAt[0]" type="date" clearable label="승인일자" placeholder=" " ></v-date-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.createdAt[1]" type="date" clearable label="승인일자" placeholder=" " ></v-date-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null;"/>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true);">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
        
        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table :loading="loading" :items="cashes" :headers="cashesHeaders" :items-per-page="limit" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template v-slot:item.amount="{item}">
                {{  Number(item.amount).format() }}
            </template>
            <template v-slot:item.remain="{item}">
                {{  Number(item.remain).format() }}
            </template>
            <template v-slot:item.createdAt="{item}">
                {{  $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />
    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        VDateField
    },
    data(){
        return {
            mdiMicrosoftExcel,
            show: false,
            loading: true,
            showSearch: true,

            filter: {
                createdAt: [this.$route.query.createdAt?.[0] || this.$dayjs().startOf('year').format("YYYY-MM-DD"), this.$route.query.createdAt?.[1] || this.$dayjs().endOf('year').format("YYYY-MM-DD")],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "CP 이름", value: "member.name" },
                { text: "CP 연락처", value: "member.phone" },
            ],

            page: 1,
            pageCount: 0,
            limit: 20,

            excelLimit: 0,

            cashes: [],
            cashesHeaders: [
                { text: "CP 이름", align: "center", width: 200, value: "cp.name" },
                { text: "비고", align: "center", width: 300, value: "remark" },
                { text: "금액", align: "center", width: 150, value: "amount" },
                { text: "남은금액", align: "center", width: 150, value: "remain" },
                { text: "내역일자", align: "center", width: 200, value: "createdAt" },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                })
            }

            this.loading = true;
            this.cashes = [];
            
            var { summary, cashes } = await api.console.cps.cashes.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.loading = false;
            this.cashes = cashes;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);

        },

        async excel(){
            try{
                var { cashes } = await api.console.cps.cashes.gets({
                    params: this.filter
                });
    
                var rows = [];
                cashes.forEach(cash => {
                    rows.push({
                        "CP 이름": cash.cp.name,
                        "비고": cash.remark,
                        "금액": parseInt(+cash.amount || 0).format(),
                        "남은금액": parseInt(+cash.remain || 0).format(),
                        "내역일자": this.$dayjs(cash.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    });
                });
    
                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);
    
                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, "CP캐시 목록.xlsx");

            }
            catch(error){
                alert(error.message);
            }
        },
    }
}
</script>